import type { Reaction } from "../types/traffic";

export const roadsideMessages = [
  "YOU ARE THE TRAFFIC",
  "PLEASE SHARE RESPONSIBLY",
  "NEXT EXIT: PRODUCTIVITY",
  "HONKING WILL DEFINITELY HELP",
  "CURRENT DELAY: YOUR FAULT",
] as const;

export const reactionLabels: Record<Reaction, string> = {
  wave: "Wave",
  sigh: "Sigh",
  coffee: "Coffee",
  turtle: "Turtle",
};

export const reactionGlyphs: Record<Reaction, string> = {
  wave: "HELLO",
  sigh: "SIGH",
  coffee: "COFFEE",
  turtle: "SLOW",
};

export const premiseCopy = {
  eyebrow: "A LIVE WEB EXPERIMENT",
  title: "THE INTERNET TRAFFIC JAM",
  body: "Every person here becomes a car. More people means slower traffic.",
  merge: "Merge Into Traffic",
  mergeAgain: "Merge Back In",
} as const;
